import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import {
  defaultColor,
  themeColorStorageKey,
} from '../../constants/defaultValues';

export default class TopnavDarkSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDark: false,
      tooltipOpen: false,
    };
  }

  componentDidMount() {
    const color = this.getColor();
    this.setState({ isDark: color.indexOf('dark') > -1 });
  }

  getColor = () => localStorage.getItem(themeColorStorageKey) || defaultColor;

  // changeMode = () => {
  //   let color = this.getColor();
  //   if (color.indexOf('dark') > -1) {
  //     color = color.replace('dark', 'light');
  //   } else {
  //     color = color.replace('light', 'dark');
  //   }
  //   localStorage.setItem(themeColorStorageKey, color);
  //   this.setState({ isDark: color.indexOf('dark') > -1 }, () => {
  //     setTimeout(() => window.location.reload(), 500);
  //   });
  // };

  changeMode = () => {
    let color = this.getColor();

    const isDark = color.includes('dark');

    const newColor = isDark
      ? color.replace('dark', 'light')
      : color.replace('light', 'dark');

    localStorage.setItem(themeColorStorageKey, newColor);

    console.log('OLD:', color);
    console.log('NEW:', newColor);

    this.setState({ isDark: !isDark });

    window.location.reload();
  };
  toggleTooltip = () =>
    this.setState((prev) => ({ tooltipOpen: !prev.tooltipOpen }));

  render() {
    const { isDark, tooltipOpen } = this.state;

    return (
      <>
        <button
          id="dark-mode-toggle-btn"
          onClick={this.changeMode}
          className="header-icon btn btn-empty d-sm-inline-block"
          style={{
            padding: '6px',
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          {isDark ? (
            // Sun icon — shown in dark mode to switch back to light
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            // Moon icon — shown in light mode to switch to dark
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>

        <Tooltip
          placement="bottom"
          isOpen={tooltipOpen}
          target="dark-mode-toggle-btn"
          toggle={this.toggleTooltip}
          delay={{ show: 200, hide: 100 }}
        >
          {isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        </Tooltip>
      </>
    );
  }
}
